import React from 'react';
import PropTypes from 'prop-types';
import HandIcon from '../../../../public/assets/images/theme-2/icons/hand.svg';
import StarIcon from '../../../../public/assets/images/theme-2/icons/asterisk-white.svg';
import ImmersiveReaderButton from '../../ImmersiveReaderButton';
import { ToolbarWrapper, ToolbarButton, HeaderRequestFeedback } from '../styles';

const HeaderToolbar = ({
  isEditable,
  report,
  isTeacher,
  showToolbar,
  setShowToolbar,
  toggleComments,
  editorId = 'contentEditor',
}) => {
  const { uuid: entityId, type: entityType } = report || {};
  const eventData = { detail: { entityId, entityType, editorId } };

  const toggleToolbar = () => {
    setShowToolbar(!showToolbar);
  };

  const addAttachment = () => {
    document.dispatchEvent(new CustomEvent('addAttachment', eventData));
  };

  const uploadVideo = () => {
    document.dispatchEvent(new CustomEvent('uploadVideo', eventData));
  };

  const uploadAudio = () => {
    document.dispatchEvent(new CustomEvent('uploadAudio', eventData));
  };

  const defaultToggleComments = () => {
    document.dispatchEvent(new CustomEvent('toggleComments', eventData));
  };

  return (
    <ToolbarWrapper>
      <ImmersiveReaderButton />
      {isEditable && (
        <>
          <ToolbarButton className="attachment" onClick={addAttachment} title={i18n.__('editor_tooltip_upload_file')} />
          <ToolbarButton className="video" onClick={uploadVideo} title={i18n.__('editor_tooltip_record_video')} />
          <ToolbarButton className="audio" onClick={uploadAudio} title={i18n.__('editor_tooltip_record_audio')} />
          <ToolbarButton
            className={`toggle ${showToolbar ? 'show' : ''}`}
            onClick={toggleToolbar}
            title={showToolbar ? i18n.__('editor_tooltip_hide_toolbar') : i18n.__('editor_tooltip_show_toolbar')}
          />
        </>
      )}
      {!isTeacher && (
        <HeaderRequestFeedback
          isEditable={isEditable}
          onClick={toggleComments || defaultToggleComments}
          src={isEditable ? HandIcon : StarIcon}
        />
      )}
    </ToolbarWrapper>
  );
};

export default HeaderToolbar;

HeaderToolbar.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  report: PropTypes.object,
  isTeacher: PropTypes.bool.isRequired,
  showToolbar: PropTypes.bool.isRequired,
  setShowToolbar: PropTypes.func.isRequired,
  toggleComments: PropTypes.func,
};
